import dayjs from 'dayjs';

export interface INetMeteringPolicy {
  id?: number;
  effectiveDate?: dayjs.Dayjs | null;
  percentage?: number | null;
}

export const defaultValue: Readonly<INetMeteringPolicy> = {};
